import apiCall from '../app/apiCall.js';

export function fetchClosedBidSessions(categoryId) {
  return () => {
    const closedBidUrl = 'preferences/bid-sessions/';
    return apiCall(closedBidUrl, 'post', { categoryId, closed: true });
  };
}
